import { useFormContext } from 'react-hook-form';
import { useEventMapContext } from 'src/contexts/EventMapContext';
import { Checkbox } from 'src/core/interim/Checkbox';
import { posChangedField } from 'src/utils/posFieldUtils';
import { SponsoredListingsCampaignInput } from 'src/WebApiController';

import * as styles from './CampaignModal.css';

export const ZoneSelectorPanel = ({
  disabled,
  onHoverTicketClass,
}: {
  disabled: boolean;
  onHoverTicketClass?: (id: number | null) => void;
}) => {
  const { ticketClasses, venueMapInfo } = useEventMapContext();
  const { watch, setValue } = useFormContext<SponsoredListingsCampaignInput>();
  const targetTicketClassIds = watch('targetTicketClassIds');

  return (
    <div className={styles.zoneSelectorPanel}>
      <div className={styles.zoneSelectorHeader}>
        {ticketClasses.length} Event Zone
        {ticketClasses.length !== 1 ? 's' : ''}
      </div>
      <div className={styles.zoneSelectorList}>
        {ticketClasses.map((tc) => {
          const isChecked =
            targetTicketClassIds?.value?.includes(tc.id) ?? false;
          const sectionCount =
            venueMapInfo?.sections?.filter((s) =>
              s.rows?.some((r) => r.tktClass?.id === tc.id)
            ).length ?? 0;
          return (
            <div
              key={tc.id}
              className={styles.zoneSelectorRow}
              onMouseEnter={() => onHoverTicketClass?.(tc.id)}
              onMouseLeave={() => onHoverTicketClass?.(null)}
            >
              <div className={styles.zoneSelectorCheckboxWrapper}>
                <Checkbox
                  disabled={disabled}
                  checked={isChecked}
                  labelPosition="right"
                  label={
                    <div className={styles.zoneSelectorRowContent}>
                      <span className={styles.zoneSelectorRowName}>
                        {tc.name}
                      </span>
                      <span className={styles.zoneSelectorRowSectionCount}>
                        {sectionCount}{' '}
                        {sectionCount === 1 ? 'section' : 'sections'}
                      </span>
                    </div>
                  }
                  onChange={() => {
                    const currentIds = targetTicketClassIds?.value ?? [];
                    const newIds = isChecked
                      ? currentIds.filter((id) => id !== tc.id)
                      : [...currentIds, tc.id];
                    setValue(
                      'targetTicketClassIds',
                      posChangedField(newIds.length > 0 ? newIds : [])
                    );
                  }}
                />
              </div>
              <span
                className={styles.zoneSelectorColorSwatch}
                style={{ backgroundColor: tc.color }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
